__turbopack_context__.v({
  "container": "HeroSection-module-scss-module__0ZFpaa__container",
  "content": "HeroSection-module-scss-module__0ZFpaa__content",
  "mediaWrapper": "HeroSection-module-scss-module__0ZFpaa__mediaWrapper",
  "socialButton": "HeroSection-module-scss-module__0ZFpaa__socialButton",
});
